import { Switch } from '@trackman/web-shared-components';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { ReactComponent as LightIcon } from 'images/light.svg';
import { ReactComponent as DarkIcon } from 'images/dark.svg';
import styled from 'styled-components';
import { useStores } from 'index';

const DarkModeWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;

  && .Mui-checked + .MuiSwitch-track,
  && .MuiSwitch-track {
    background-color: ${({ theme }) => theme.darkModeBackground};
    border: 1.5px solid ${({ theme }) => theme.darkModeBorder};
  }
`;

const Divider = styled.div`
  width: 1px;
  height: 20px;
  background-color: #7b7b7b;
  margin: 0 16px;
`;

const DarkModeSwitch = observer(() => {
  const liveDashboardStore = useStores().liveDashboardStore;

  const changeHandler = (event: React.ChangeEvent<any>): void => {
    liveDashboardStore.setDarkMode(!event.target.checked);
  };

  useEffect(() => {
    document.querySelector('body')?.setAttribute('data-theme', liveDashboardStore.darkMode ? 'dark' : 'light');
  }, [liveDashboardStore.darkMode]);

  return (
    <DarkModeWrapper>
      <LightIcon style={{ marginRight: '8px' }} />
      <Switch label='' checked={liveDashboardStore.darkMode} onChange={changeHandler} withoutBorder />
      <DarkIcon />
      <Divider />
    </DarkModeWrapper>
  );
});

export default DarkModeSwitch;
